import { useState } from "react";
import { Modal } from "flowbite-react";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { IVehicleTransfer } from "@/types/vehicleTransfer.type";
import Loading from "@/common/components/ui/loading/Loading";
import { useToastContext } from "@/common/components/ui/toast/toast.context";

import { updateVehicleTransfer } from "@/common/services/vehiclesTransfer.api";
import { getCompanyName } from "@/common/helpers/company.helpers";

type Props = {
  onClose: () => void;
  onSave: () => void;
  transfer: IVehicleTransfer;
};

export default function ModalConfirmTransfer({
  onClose,
  onSave,
  transfer,
}: Props) {
  const { notifySuccess, notifyError } = useToastContext();

  const [isLoading, setIsLoading] = useState(false);

  async function handleConfirm() {
    setIsLoading(true);
    try {
      const result = await updateVehicleTransfer(transfer._id, {
        status: "completed",
      });

      if (result.ok) {
        notifySuccess(`Chegada da transferência confirmada!`);
        onSave();
      } else {
        notifyError(result.message || "Falha ao confirmar a chegada.");
        onClose();
      }
    } catch (err) {
      console.error(err);
      notifyError("Ocorreu um erro de rede. Tente novamente.");
      onClose();
    } finally {
      setIsLoading(false);
    }
  }
  if (!transfer) {
    return (
      <Modal show={true} onClose={onClose}>
        <Modal.Body>
          <Loading />
        </Modal.Body>
      </Modal>
    );
  }
  return (
    <Modal show={true} size="lg" onClose={onClose} popup>
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <h3 className="mb-4 text-xl font-semibold text-gray-700">
            Confirmar Chegada
          </h3>
          <p className="mb-6 text-base text-gray-500">
            Você deseja confirmar a chegada da transferência de{" "}
            <strong>{getCompanyName(transfer.companyOriginId)}</strong> para{" "}
            <strong>{getCompanyName(transfer.companyDestinyId)}</strong>?
          </p>
          <div className="flex justify-center gap-4">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 disabled:opacity-50"
              disabled={isLoading}
            >
              Não
            </button>
            <ButtonWithLoader
              onClick={handleConfirm}
              isLoading={isLoading}
              className="bg-blue-600 hover:bg-blue-700"
            >
              Sim
            </ButtonWithLoader>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
